import { VehicleStatus } from "../../../../logic/api";
import flex from "../../../../styles/flex";

export default {
    bookingListItem: {
        backgroundColor: "white",
        position: "relative",
        border: "solid 1px lightgray",
        padding: 10,
        marginBottom: 10,
        transition: "all 0.2s ease-in-out 0s",
        textAlign: "left",
        borderRadius: 5,
        cursor: "pointer",
    } as React.CSSProperties,

    bookingListItemFlex: {
        ...flex.flexRows,
        justifyContent: "center",
        itemsAlign: "center",
        alignContent: "center",
        overflow: "hidden"

    } as React.CSSProperties,

    bookingListItemBorder: (vehicleStatus: VehicleStatus) => {
        if (vehicleStatus == VehicleStatus.NotCheckedIn) {
            return {
                border: "solid 1px rgb(3, 102, 214)",
                borderLeft: "solid 15px rgb(3, 102, 214)",
            } as React.CSSProperties;
        } else if (vehicleStatus == VehicleStatus.CheckedOut) {
            return {
                border: "solid 1px orangered",
                borderLeft: "solid 15px orangered",
            } as React.CSSProperties;
        } else {
            return {
                border: "solid 1px rgb(52, 208, 88)",
                borderLeft: "solid 15px rgb(52, 208, 88)",
            } as React.CSSProperties;
        }

    },
    icon: {
        fontSize: 24,
        marginLeft: 10,
        marginRight: 20
    } as React.CSSProperties,
    iconChevron: {
        fontSize: 24,
        marginLeft: 20,
        marginRight: 10
    } as React.CSSProperties,


}